'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RouteController = require('react-router-controller/libs/RouteController');

var _RouteController2 = _interopRequireDefault(_RouteController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 */
var ControllerBindModel = (_temp2 = _class = function (_React$Component) {
  (0, _inherits3.default)(ControllerBindModel, _React$Component);

  function ControllerBindModel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ControllerBindModel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ControllerBindModel.__proto__ || (0, _getPrototypeOf2.default)(ControllerBindModel)).call.apply(_ref, [this].concat(args))), _this), _this.firstRender = true, _this.displayName = 'MVC', _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  //第一次渲染


  (0, _createClass3.default)(ControllerBindModel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          modelRegister = _props.modelRegister,
          basename = _props.basename,
          hot = _props.hot;

      if (hot && modelRegister) {
        //热替换需要每次更新运行
        modelRegister(this.context.sagaStore.register, hot);
      } else if (this.firstRender && modelRegister) {
        this.firstRender = false;
        modelRegister(this.context.sagaStore.register, false);
      }
      return _react2.default.createElement(_RouteController2.default, { basename: basename, hot: hot });
    }
  }]);
  return ControllerBindModel;
}(_react2.default.Component), _class.propTypes = {
  modelRegister: _propTypes2.default.func.isRequired
}, _class.contextTypes = {
  sagaStore: _propTypes2.default.object
}, _temp2);
exports.default = ControllerBindModel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mvc-react/libs/controller-bind-model.js
// module id = 230
// module chunks = 0